import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import images from "../../images/laptop.jpg";
import Review from "../Review/Review";
import "./Home.css";

const Home = () => {
  const navigate = useNavigate();
  const [home, setHome] = useState([]);
  useEffect(() => {
    fetch(`data.json`)
      .then((res) => res.json())
      .then((data) => setHome(data));
  }, []);
  return (
    <section>
      <div className="home">
        <div className="text">
          <h1>World Best Laptop</h1>
          <p>
            Apple's laptops are now comprised of a 13-inch MacBook Air and three
            flavors of MacBook Pro: 13 inches, 14 inches and 16 inches. It can
            be tough deciding which MacBook to buy, especially since Apple
            offers some models with M1 chips and others with M1 Pro or M1 Max
            processors.
          </p>
          <button>Explore</button>
        </div>
        <div className="text">
          <img src={images} alt="" />
        </div>
      </div>

      <div className="customers">
        <div className="review-head">
          <h1>Customers Review(3)</h1>
        </div>
        <div className="reviews-container">
          {home.slice(0, 3).map((review) => (
            <Review key={review.id} review={review}></Review>
          ))}
          <button onClick={()=> navigate(`/review`)}>Show All</button>
        </div>
      </div>
    </section>
  );
};

export default Home;
